/**
 * Checks if a given string contains only numeric characters.
 *
 * @param {string} stringValue - The string to be checked.
 * @returns {boolean} - `true` if the string contains only numeric characters, `false` otherwise.
 */
export const checkStringIsNumber = (stringValue: string): boolean => /^\d*$/.test(stringValue);
